import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ChevronUpIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7603 14.7996C15.4568 15.0814 14.9823 15.0639 14.7004 14.7603L12 11.8522L9.2996 14.7603C9.01775 15.0639 8.5432 15.0814 8.23967 14.7996C7.93613 14.5177 7.91856 14.0432 8.20041 13.7397L11.4504 10.2397C11.5923 10.0868 11.7915 10 12 10C12.2086 10 12.4077 10.0868 12.5496 10.2397L15.7996 13.7397C16.0815 14.0432 16.0639 14.5177 15.7603 14.7996Z"
        fill="currentColor"
      />
    </svg>
  );
};
